import React, { Fragment } from 'react';
import MapPriceMarker from './MapPriceMarker';
import ActiveMarker from './ActiveMarker';

const RentalMarker = ({
  property,
  changeActiveMarker,
  activeMarker,
  highlighted,
}) => {
  return (
    <Fragment>
      {/* eslint-disable-next-line no-nested-ternary */}
      {activeMarker === property.id ? (
        <ActiveMarker
          changeActiveMarker={changeActiveMarker}
          listing={property}
          type="rental"
        />
      ) : (
        <button
          aria-label="View Property"
          name="View Property"
          className={`rental-marker ${highlighted ? 'highlighted' : ''}`}
          onClick={() => changeActiveMarker(property.id)}
          type="button"
        >
          <MapPriceMarker
            price={property.nightly_rate && property.nightly_rate}
          />
        </button>
      )}
    </Fragment>
  );
};

export default RentalMarker;
